import { render, staticRenderFns } from "./UserLoyaltyPreviewDialog.vue?vue&type=template&id=7ed89940&scoped=true"
import script from "./UserLoyaltyPreviewDialog.vue?vue&type=script&lang=js"
export * from "./UserLoyaltyPreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./UserLoyaltyPreviewDialog.vue?vue&type=style&index=0&id=7ed89940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed89940",
  null
  
)

export default component.exports